export enum CommentEvent {
	Created = 'comment-created',
	Open = 'open-comment-composer',
}
